'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var initialState = {
    isCompact: false,
    step: 1,
    processing: false,
    items: [],
    itemAmounts: [],
    giftItems: [],
    changes: {},
    updating: {},
    id: null,
    totalPriceWithoutVat: 0,
    totalPriceWithVat: 0,
    totalVat: 0,
    dispatchSeparately: false,
    note: null,
    processingOrdersPrice: 0,
    minPriceForDispatch: 0,
    maxAmountPerItem: 0,
    canCreateOrder: false,
    canChangeCart: false,
    dispatchWarning: false,
    offlineMode: false,
    offlineModeMessage: null,
    sendOrderDisabledReason: null,
    showStockAmountSeparately: false,
    notifyMessages: [],
    amountAvailableLimit: 0,
    massOrderSummary: {},
    processedProductIds: [],
    loyaltyProgramAvailable: false,

    changedOptions: {},
    optionsVersion: 0,
    savedOptionsVersion: 0,
    savingOptionsVersion: null
};

function numbersOnly(value) {
    if (typeof value !== 'string') value = '';
    return value.replace(/\D/g, '');
}

function getNumber(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') value = null;
    value = parseInt(value, 10);
    if (isNaN(value)) {
        value = null;
    }
    return value;
}

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {
        case _actionTypes2.default.SETTING_COUPON:
            newState = (0, _extends3.default)({}, state, { settingCoupon: true });
            break;
        case _actionTypes2.default.COUPON_SET:
            newState = (0, _extends3.default)({}, state, { settingCoupon: false });
            break;
        case _actionTypes2.default.ORDERING:
            newState = (0, _extends3.default)({}, state, { sendingOrder: true });
            break;
        case _actionTypes2.default.ORDER_FAILED:
            newState = (0, _extends3.default)({}, state, { sendingOrder: false });
            break;

        case _actionTypes2.default.CHANGE_STEP:
            newState = (0, _extends3.default)({}, state, { step: action.step });
            break;

        case _actionTypes2.default.ADD_BY_EAN:
            newState = (0, _extends3.default)({}, state, { addByEan: { ean: action.ean, amount: action.amount } });
            break;

        case _actionTypes2.default.UPDATE:
            {
                newState = (0, _extends3.default)({}, state, { processing: false, updating: {} }, action.cart);

                // populate items in catalog objects
                if (newState.catalogs) {
                    var catalogHelper = {};
                    var uncategorizedItems = [];

                    // enhance each catalog with list of its items
                    (0, _forEach2.default)(newState.catalogs, function (catalog) {
                        catalog.items = [];
                        catalogHelper[catalog.id] = catalog;
                    });

                    var items = [].concat((0, _toConsumableArray3.default)(newState.items));
                    // for each item in the cart try to find the catalog to which it belongs
                    while (items.length > 0) {
                        var item = items.pop();
                        if (item.catalogId && item.catalogId.length > 0) {
                            var catalogIdx = 0;
                            var catalogFound = false;
                            // each item may be included in multiple catalogs, but only those which are in the "catalogs" collection are valid
                            // so we need to find the first visible catalog for this item (if possible)
                            while (catalogIdx < item.catalogId.length) {
                                var catalogId = item.catalogId[catalogIdx];
                                if (catalogId && catalogHelper.hasOwnProperty(catalogId)) {
                                    var c = catalogHelper[catalogId];
                                    if (c) {
                                        c.items.push(item);
                                        catalogFound = true;
                                        break;
                                    }
                                }
                                catalogIdx++;
                            }

                            // if no visible catalog is found, the item is to be shown under "uncategorized" section (a fake catalog basically)
                            if (!catalogFound) {
                                uncategorizedItems.push(item);
                            }
                        } else {
                            uncategorizedItems.push(item);
                        }
                    }

                    if (uncategorizedItems.length > 0) {
                        var uncat = {
                            items: uncategorizedItems,
                            id: 0,
                            name: Resx.App.CartItemsWithoutCatalogTitle
                        };

                        newState.catalogs.push(uncat);
                    }
                }

                if (Array.isArray(newState.notifyMessages)) {
                    newState.notifyMessages.forEach(function (v) {
                        return _abp2.default.notify.warn(v);
                    });
                }
                break;
            }
        case _actionTypes2.default.CHANGE_AMOUNT:
            {
                newState = (0, _merge2.default)({}, state);
                var maxAmount = state.maxAmountPerItem || 0;
                var origAmountInt = action.origAmount || (state.items.find(function (i) {
                    return i.productId === action.productId;
                }) || {}).amount || null;
                var origAmount = origAmountInt === null ? '' : origAmountInt + '';
                var newAmount = numbersOnly(action.amount);
                var newAmountInt = getNumber(newAmount);
                if (newAmountInt <= maxAmount || newAmountInt < origAmountInt) {
                    if (newAmount === origAmount) {
                        delete newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)];
                    } else {
                        newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)] = {
                            productId: action.productId,
                            giftId: action.giftId,
                            price: action.price,
                            catalogId: action.catalogId,
                            amount: newAmountInt,
                            displayAmount: newAmount,
                            processing: false
                        };
                    }
                }
                break;
            }
        case _actionTypes2.default.LOAD_DATA:
            newState = (0, _assign2.default)({}, state, { processing: true });
            break;

        case _actionTypes2.default.SUBMIT_CHANGES:
            newState = (0, _merge2.default)({}, state, { processing: true });
            newState.changes = (0, _extends3.default)({}, newState.changes);
            newState.updating = (0, _extends3.default)({}, newState.updating);

            action.items.map(function (i) {
                return { key: (0, _linksoftAlbatros.getCartChangeKey)(i), item: i };
            }).forEach(function (x) {
                var change = newState.changes[x.key];
                if (!change) {
                    change = { productId: x.item.productId };
                } else {
                    delete newState.changes[x.key];
                }
                newState.updating[x.key] = change;
            });
            break;

        case _actionTypes2.default.UPDATE_FAILED:
            newState = (0, _assign2.default)({}, state, { processing: false, changes: {}, updating: {} });
            break;

        // case Types.DISCARD_CHANGES:
        //     newState = merge({}, state);
        //     if (action.productId) {
        //         delete newState.changes[getChangeKey(action)];
        //     } else {
        //         newState.changes = {}; // clean entire shopping cart
        //     }
        //     break;
        case _actionTypes2.default.OPTIONS_CHANGED:
            newState = (0, _extends3.default)({}, state, { changedOptions: (0, _extends3.default)({}, state.changedOptions, action.options), optionsVersion: state.optionsVersion + 1 });
            break;
        case _actionTypes2.default.OPTIONS_SAVING:
            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: action.version });
            break;
        case _actionTypes2.default.OPTIONS_SAVING_FAILED:
            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: null, changedOptions: {} });
            break;
        case _actionTypes2.default.OPTIONS_SAVED:
            {
                var changedOptions = state.optionsVersion !== action.version ? state.changedOptions : {};
                newState = (0, _extends3.default)({}, state, { savedOptionsVersion: action.version, savingOptionsVersion: null, changedOptions: changedOptions });
                break;
            }
        case _actionTypes2.default.MASS_ORDER_SUMMARY:
            {
                newState = (0, _extends3.default)({}, state, { massOrderSummary: action.result });
                break;
            }
        case _actionTypes2.default.PROCESSED_PRODUCTS:
            {
                newState = (0, _extends3.default)({}, state, { processedProductIds: action.processedProductIds });
                break;
            }
        case _actionTypes2.default.LOYALTY_PROGRAM_CHECK:
            {
                newState = (0, _extends3.default)({}, state, { loyaltyProgramAvailable: action.loyaltyProgramAvailable });
                break;
            }
    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/reducer.js
// module id = 1153
// module chunks = 0